import React from 'react';
import {inject, observer} from 'mobx-react';
import {injectIntl} from 'react-intl';
import {Row, Col, Panel, Select } from 'react-bootstrap';
import GeneralTicketsStatistics from './analytics_components/GeneralTicketsStatistics';
import NewAndSolvedTicketsPlot from './analytics_components/NewAndSolvedTicketsPlot';
import SatisfactionRatePlot from './analytics_components/SatisfactionRatePlot';
import FirstReplyStatistics from './analytics_components/FirstReplyStatistics';
import PeriodSelect from './analytics_components/PeriodSelect';
import PrioritiesPlot from './analytics_components/PrioritiesPlot'; 

@injectIntl @inject('analyticsStore') @observer
export default class Analytics extends React.Component{

    componentDidMount(){
        this.props.analyticsStore.fetchData();
    }

    render() {
        const {intl, analyticsStore} = this.props;
        return (
            <div>
                <PeriodSelect />
                <Panel>
                    <h3>{intl.formatMessage({id: 'tickets_statistics_title' })}</h3>
                    <br/>
                    <GeneralTicketsStatistics />
                    <NewAndSolvedTicketsPlot/>
                </Panel>
                <Row>
                    <Col xs={12} md={4}>
                        <SatisfactionRatePlot />
                    </Col>
                    <Col xs={12} md={4}>
                        <PrioritiesPlot />
                    </Col>
                    <Col xs={12} md={4}>
                        <FirstReplyStatistics />
                    </Col>
                </Row>
            </div>
        );
    }
}